import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import withResponsive from "../hoc/withResponsive";

export default withResponsive({
  name: "slider",

  ui: {
    pagination: "[js-slider-pagination]",
    navigation: "[js-slider-navigation]",
    slider: "[js-slider-el]",
  },

  componentDidMount() {
    if (!this.ui.slider) {
      console.warn("Slider element not found");
      return;
    }

    const swiper = new Swiper(this.ui.slider, {
      modules: [Navigation, Pagination],
      pagination: {
        el: '[js-slider-pagination]',
        type: 'bullets',
      },
      loop: this.ui.slider.dataset.loop ? true : false,
      initialSlide: parseInt(this.ui.slider.dataset.initialslide) || 0,
      slidesPerView: parseFloat(this.ui.slider.dataset.slidesperview),
      spaceBetween: parseInt(this.ui.slider.dataset.spacebetween),
      breakpoints: this.ui.slider.dataset.breakpoints
        ? JSON.parse(this.ui.slider.dataset.breakpoints)
        : false,
      navigation: this.ui.navigation
        ? {
            nextEl: this.ui.navigation.querySelector(".swiper-button-next"),
            prevEl: this.ui.navigation.querySelector(".swiper-button-prev"),
          }
        : {},
    });

    this.swiper = swiper;

    if (this.ui.slider.dataset.slideTo) {
      swiper.slideTo(parseInt(this.ui.slider.dataset.slideTo), 0);
    }
  },

  componentWillUnmount() {
    this.off();

    this.slider.destroy();
    if (this.ui.pagination) this.ui.pagination.innerHTML = "";
  },
});

// init Swiper:
// document.addEventListener("DOMContentLoaded", function () {

// });
